import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[zaaAutofocus]',
  standalone: true
})
export class ZaaAutofocusDirective implements AfterViewInit {
  constructor(private element: ElementRef<HTMLInputElement>) { }

  ngAfterViewInit(): void {
    this.element.nativeElement.focus();
  }
}